
export default {
  name: 'UpgradeModal',
  data() {
    return {
      show: false,
      type: 'feature', // 'feature', 'limit', or 'activation'
      message: '',
      feature: '',
      limit: null,
      user: null,
      companyName: '',
      emailSent: false,
      sendingEmail: false
    }
  },
  computed: {
    progressPercentage() {
      if (!this.limit || !this.limit.max) return 0;
      return Math.min((this.limit.current / this.limit.max) * 100, 100);
    }
  },
  methods: {
    showModal(data = {}) {
      this.show = true;
      this.type = data.error === 'limit_reached' ? 'limit' :
                  data.error === 'activation_required' ? 'activation' : 'feature';
      this.message = data.message || 'Deze functie vereist een upgrade.';
      this.feature = data.feature || '';
      this.limit = data.limit || null;

      // Store user and company info for upgrade email
      this.user = data.user || (this.$nuxt && this.$nuxt.$auth && this.$nuxt.$auth.user) || null;
      this.companyName = data.companyName || 'Unknown Company';

      // Reset email states for fresh modal instance
      this.emailSent = false;
      this.sendingEmail = false;
    },

    hide() {
      this.show = false;
      // Reset data
      this.type = 'feature';
      this.message = '';
      this.feature = '';
      this.limit = null;
      this.user = null;
      this.companyName = '';
      this.emailSent = false;
      this.sendingEmail = false;
    },

    async goToUpgrade() {
      // Send upgrade email request
      await this.sendUpgradeEmail();

      // Navigate to subscription settings page
      // Use $nuxt.$router for global components that don't have direct router access
      // if (this.$nuxt && this.$nuxt.$router) {
      //   this.$nuxt.$router.push('/instellingen/subscription');
      // } else if (this.$router) {
      //   this.$router.push('/instellingen/subscription');
      // } else {
      //   // Fallback: use window.location
      //   window.location.href = '/instellingen/subscription';
      // }
      this.hide();
    },

    async sendUpgradeEmail() {
      // Prevent multiple sends
      if (this.emailSent || this.sendingEmail) {
        return;
      }

      this.sendingEmail = true;

      try {
        // Get API instance - try multiple sources
        let api = null;
        if (this.$nuxt && this.$nuxt.$api) {
          api = this.$nuxt.$api;
        } else if (typeof window !== 'undefined' && window.$nuxt && window.$nuxt.$api) {
          api = window.$nuxt.$api;
        } else if (this.$api) {
          api = this.$api;
        }

        if (!api) {
          console.error('API instance not available');
          return;
        }

        // Get company name if not provided
        let companyName = this.companyName;
        if ((!companyName || companyName === 'Unknown Company') && this.user && this.user.companyId) {
          try {
            const companyResponse = await api.get(`companies/read?companyId=${this.user.companyId}`);
            if (companyResponse.data && companyResponse.data[0] && companyResponse.data[0].name) {
              companyName = companyResponse.data[0].name;
            }
          } catch (companyError) {
            console.warn('Failed to fetch company name:', companyError);
            // Continue with Unknown Company as fallback
          }
        }

        // Send upgrade request email
        const response = await api.post('subscription/send-upgrade-request', {
          feature: this.feature || 'general',
          company_name: companyName,
          user_email: this.user ? this.user.email : '',
          user_name: this.user ? `${this.user.firstname || ''} ${this.user.lastname || ''}`.trim() : ''
        });

        if (response.data && response.data.success) {
          this.emailSent = true;
          // Show success message
          if (typeof window !== 'undefined' && window.alert) {
            alert('Upgrade verzoek verzonden! Een medewerker neemt spoedig contact met u op.');
          }
        } else {
          if (typeof window !== 'undefined' && window.alert) {
            alert('Er is een fout opgetreden. Probeer het later opnieuw.');
          }
        }
      } catch (error) {
        console.error('Failed to send upgrade email:', error);
        if (typeof window !== 'undefined' && window.alert) {
          alert('Er is een fout opgetreden bij het verzenden van het upgrade verzoek.');
        }
      } finally {
        this.sendingEmail = false;
      }
    }
  }
}
